import { useEffect, useState } from "react";
import { Badge, Menu, MenuItem } from "@mui/material";
import { useConnect } from "@stacks/connect-react";
import { AnchorMode, boolCV, bufferCVFromString, intCV, listCV, noneCV, optionalCVOf, principalCV, stringAsciiCV, stringUtf8CV, tupleCV, uintCV } from "@stacks/transactions";
import { authenticatedUserAddress, network, userBalance } from "../auth";
import { getCosts, getDeruptCoreContractPrivately } from "../chime";
import { clientNetwork, cryptoCashTokenAddress, profileContract } from "../../lib/constants";
import { fees } from "../../lib/fees";
import { dynamicPostConditionListForUsers, mergePostConditions } from "../dynamicLibs";
import { BsHeart, BsHeartbreak, BsHeartbreakFill, BsHeartFill } from "react-icons/bs";
import { SlPuzzle } from "react-icons/sl";

const appOrigin = window.location.origin;
const userAddress = authenticatedUserAddress({ network: clientNetwork });

export const SentimentButton = ({
    // Sentiments identifyer for either like or dislike
    sentiment,
    text,
    // State setter's
    setOpenConfirmModal,
    setOpenSnackBar,
    setTx_Id,
    setErrorMsg,
    // State value
    txId,
    // This amount value can either be likeFtAmount or disLikeFtAmount
    ftAmount,
    authorPrincipal,
    // This extras value is only passed along from the extension's modal
    extras
}) => {
    // Stacks doContract call method
    const { doContractCall } = useConnect();

    const doSentimentCall = async () => {
        console.log('look here please', { extras });
        // Compares authed user to chimeAuthor
        if (userAddress === authorPrincipal) {
            setErrorMsg("Interacting with your own content is not possible");
            setOpenSnackBar(true);
            return;
        }

        // This retrieve's and compare's user balance if users 
        // meets required balance to execute this function
        const { likeFtCost, dislikeFtCost } = await getCosts();
        const { ft_grand_total } = (await fees(0)).getLikeMessageTotal();
        const usersBalance = await userBalance({ token_asset_id: cryptoCashTokenAddress });
        if ((usersBalance[cryptoCashTokenAddress] || 0) < ft_grand_total) {
            setErrorMsg('Insufficient Fungible Token Balance');
            setOpenSnackBar(true);
            return;
        }

        // PostCondition's construct
        const clientPostConditions = {
            list: [{ type: 'ft', contractAddress: cryptoCashTokenAddress }],
            values: [{ uint: ft_grand_total }]
        };
        const userDynamicPostConditions = {
            list: extras?.postconditions ? Object.keys(extras.postconditions).map(key => extras.postconditions[key]) : [],
            values: extras?.values ? Object.keys(extras.values).map(key => extras.values[key]) : []
        };

        let extFeeAndCommitDynamicPostConditions = Array.isArray(extras?.postconditions) ? extras?.postconditions.filter(res => (res?.type && res?.contractAddress) && (res?.fee && res?.commit)) : [];
        extFeeAndCommitDynamicPostConditions = {
            list: extFeeAndCommitDynamicPostConditions,
            values: extFeeAndCommitDynamicPostConditions.map(res => { return { uint: res?.fee || res?.commission } })
        };

        const combinedPostConditions = [
            ...clientPostConditions.list.map((item, index) => ({ ...item, value: clientPostConditions.values[index]?.uint || 0 })),
            ...userDynamicPostConditions.list.map((item, index) => ({ ...item[index], value: userDynamicPostConditions.values[index]?.uint || 0 })),
            ...extFeeAndCommitDynamicPostConditions.list.map((item, index) => ({ ...item, value: extFeeAndCommitDynamicPostConditions.values[index]?.uint || 0 }))
        ];


        const duplicateCleanUp = mergePostConditions(combinedPostConditions);

        const postConditions = dynamicPostConditionListForUsers(duplicateCleanUp);
        const deruptCoreContract = await getDeruptCoreContractPrivately();
        const extensionContract = extras?.extensionAddress ? optionalCVOf(principalCV(extras?.extensionAddress)) : noneCV();
        const extrasConstruct = Object.keys(extras?.values || {});
        // const listLength = extras?.values['listlength'];
        const finalExtras = extrasConstruct.length
            ? optionalCVOf(listCV(
                Array.from({ length: 1 }, (_, index) => {
                    return tupleCV({
                        "stringutf8": extras?.values[index]["stringutf8"] ? optionalCVOf(stringUtf8CV(extras?.values[index]["stringutf8"])) : noneCV(),
                        "stringascii": extras?.values[index]["stringascii"] ? optionalCVOf(stringAsciiCV(extras?.values[index]["stringascii"])) : noneCV(),
                        "uint": extras?.values[index]["uint"] ? optionalCVOf(uintCV(extras?.values[index]["uint"])) : noneCV(),
                        "int": extras?.values[index]["int"] ? optionalCVOf(intCV(extras?.values[index]["int"])) : noneCV(),
                        "principal": extras?.values[index]["principal"] ? optionalCVOf(principalCV(extras?.values[index]["principal"])) : noneCV(),
                        "bool": extras?.values[index]["bool"] ? optionalCVOf(boolCV(extras?.values[index]["bool"])) : noneCV(),
                        "buff": extras?.values[index]["buff"] ? optionalCVOf(bufferCVFromString(extras?.values[index]["buff"])) : noneCV(),
                        "proxy": extras?.values[index]["proxy"] ? optionalCVOf(bufferCVFromString(extras?.values[index]["proxy"])) : noneCV()
                    })
                })
            ))
            : noneCV();
        console.log({ sentiment });
        doContractCall({
            contractAddress: userAddress,
            contractName: profileContract,
            functionName: sentiment ? 'like-message' : 'dislike-message',
            functionArgs: sentiment
                ? [
                    principalCV(authorPrincipal),
                    stringUtf8CV(txId),
                    principalCV(cryptoCashTokenAddress.split('::')[0]),
                    principalCV(deruptCoreContract),
                    uintCV(ftAmount || likeFtCost),
                    stringUtf8CV(appOrigin),
                    extensionContract,
                    finalExtras
                ]
                : [
                    principalCV(authorPrincipal),
                    stringUtf8CV(txId),
                    principalCV(cryptoCashTokenAddress.split('::')[0]),
                    principalCV(deruptCoreContract),
                    uintCV(ftAmount || dislikeFtCost),
                    uintCV(1),
                    stringUtf8CV(appOrigin),
                    extensionContract,
                    finalExtras
                ],
            network: network({ network: clientNetwork }),
            validateWithAbi: true,
            anchorMode: AnchorMode.Any,
            postConditions,
            onFinish: ({ txId }) => {
                setTx_Id(txId);
                setOpenConfirmModal(true);
            },
            onCancel: () => {
                console.log("Action aborted");
            }
        });
    }

    return (
        <div onClick={doSentimentCall}>
            <img src={`${appOrigin}/32-cc.png`} alt='' />
            {text && (<p>{text}</p>)}
        </div>
    )
}

export const SentimentMenue = ({
    // Sentiments identifyer for either like or dislike
    sentiment,
    // State setters
    setOpenExtensionModal,
    setOpenConfirmModal,
    setOpenSnackBar,
    setErrorMsg,
    setExtensionAction,
    setTx_Id,
    // State Values
    extensionAction,
    Tx_ID,
    // Content sentiments values
    counts,
    likedOrDisliked,
    ftAmount,
    // validate contract
    validate,
    // Content Author
    chimeAuthorPrincipal,
    // User Settings/ContractValidation
    userSettings,
}) => {
    const [anchorLike, setAnchorLike] = useState(null);
    const [openSentiment, setOpenSentiment] = useState(false);

    const handleOpenExtensionModal = () => {
        setOpenExtensionModal(true);
        setOpenSentiment(false);
    };
    const handleOpenSentimentMenue = (e) => {
        setAnchorLike(e.currentTarget);
        validate(setOpenSentiment, true);
    };

    const handleCloseSentimentMenue = () => {
        setOpenSentiment(false)
    };

    return (
        <div>
            <button className="derupt-button" id="basic-button" aria-controls={openSentiment ? 'basic-menu' : false} aria-haspopup="true" aria-expanded={openSentiment ? 'true' : false} onClick={handleOpenSentimentMenue}>
                {sentiment
                    ? <Badge sx={{ zIndex: '0' }} badgeContent={counts} color="warning" anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}>{likedOrDisliked ? <BsHeartFill size={24} /> : <BsHeart size={24} />}</Badge>
                    : <Badge sx={{ zIndex: '0' }} badgeContent={counts} color="warning" anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}>{likedOrDisliked ? <BsHeartbreakFill size={24} /> : <BsHeartbreak size={24} />}</Badge>
                }
            </button>
            <Menu id="basic-menu" anchorEl={anchorLike} open={openSentiment} onClose={handleCloseSentimentMenue} MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                <MenuItem disabled={likedOrDisliked} onClick={() => {
                    handleCloseSentimentMenue();
                }}>
                    <SentimentButton
                        sentiment={sentiment}
                        text={extensionAction}

                        setOpenConfirmModal={setOpenConfirmModal}
                        setOpenSnackBar={setOpenSnackBar}
                        setTx_Id={setTx_Id}
                        setErrorMsg={setErrorMsg}

                        txId={Tx_ID}

                        ftAmount={ftAmount}
                        authorPrincipal={chimeAuthorPrincipal}
                    />
                </MenuItem>
                <MenuItem onClick={() => {
                    setExtensionAction(sentiment ? 'like-message' : 'dislike-message');
                    handleOpenExtensionModal();
                    handleCloseSentimentMenue();
                }}>
                    <SlPuzzle id="extension-icon" size={32} />
                </MenuItem>
            </Menu>
        </div>
    );
}